<style>

.container{
  box-sizing: border-box;
  width: 100%;
  display: table;
}
.row{
  width: 100%;
  display: table-row;
}
.cell{
  display: table-cell;
  padding: 5px;
  text-align: center;
  border: 1px #0000 solid;
}
.weekdays{
  font-size: 14px;
  color: #777;
}

.nav{
  display: grid;
  grid-template-columns: 32px auto 32px;
  margin: 10px 0;
}
.left{
  grid-column: 1;
}
.center{
  grid-column: 2;
}
.right{
  grid-column: 3;
}
.icon-arrow_left, .icon-arrow_right{
  font-size: 29px;
}

.today{
  background-color: rgba(0, 0, 0, 0.1);
}
.selected{
  background-color: rgba(255, 227, 165, 0.8);
  border: 1px black solid;
}
</style>

<div class="nav">
  <div class="left" on:click="{previousMonth}"> <i class="icon-arrow_left"></i> </div>
  <div class="center">{months[curMonth]} {curYear}</div>
  <div class="right" on:click="{nextMonth}"> <i class="icon-arrow_right"></i> </div>
</div>
<div class="container">
  <div class="row">
    {#each daysOfWeek as item}
    <div class="cell weekdays">{item}</div>
    {/each}
  </div>
  
  <div class="row">
    {#each emptyDays as item}
      <div class="cell"></div>
    {/each}
    
    {#each weeks[0] as item}
      
      {#if isSelected(item, selectedDate)}
      <div class="cell selected">{item}</div>
      {:else if isToday(item)}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell today">{item}</div>
      {:else}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell">{item}</div>
      {/if}
    
    {/each}
  </div>

  <div class="row">
    {#each weeks[1] as item}
      {#if isSelected(item, selectedDate)}
      <div class="cell selected">{item}</div>
      {:else if isToday(item)}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell today">{item}</div>
      {:else}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell">{item}</div>
      {/if}
    {/each}
  </div>

  <div class="row">
    {#each weeks[2] as item}
      {#if isSelected(item, selectedDate)}
      <div class="cell selected">{item}</div>
      {:else if isToday(item)}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell today">{item}</div>
      {:else}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell">{item}</div>
      {/if}
    {/each}
  </div>

  <div class="row">
    {#each weeks[3] as item}
      {#if isSelected(item, selectedDate)}
      <div class="cell selected">{item}</div>
      {:else if isToday(item)}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell today">{item}</div>
      {:else}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell">{item}</div>
      {/if}
    {/each}
  </div>

  <div class="row">
    {#each weeks[4] as item}
      {#if isSelected(item, selectedDate)}
      <div class="cell selected">{item}</div>
      {:else if isToday(item)}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell today">{item}</div>
      {:else}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell">{item}</div>
      {/if}
    {/each}
  </div>

  <div class="row">
    {#each weeks[5] as item}
      {#if isSelected(item, selectedDate)}
      <div class="cell selected">{item}</div>
      {:else if isToday(item)}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell today">{item}</div>
      {:else}
      <div on:click="{ () => {selectThisDate(item)} }" class="cell">{item}</div>
      {/if}
    {/each}
  </div>

</div>

<script>

export let date = "2024-02-29";

$:{
  if (date) {
    // parse date into a selection
    let s = date.split("-");
    if (s.length == 3) {
      let now = new Date(s[0], s[1]-1, s[2]);
      curYear = now.getFullYear();
      curMonth = now.getMonth();
      curDate = now.getDate();
      selectedYear = now.getFullYear();
      selectedMonth = now.getMonth();
      selectedDate = now.getDate();
      calcMonth(now);
    }
  }
}

let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

let daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

let curYear = 0;
let curMonth = 0;
let curDate = 0;

/*
weeks is defined like:
[
  [1,2,3,4,5...],
  [6,7,8,9,0...],
]
*/
let weeks = [ [], [], [], [], [], [], ];

let startDay = 0;
let emptyDays = [];
let daysInMonth = 0;
let curWeek = 0;
let curDay = 0;
let today = new Date();
let todayYear = today.getFullYear();
let todayMonth = today.getMonth();
let todayDate = today.getDate();

let selectedYear = todayYear;
let selectedMonth = todayMonth;
let selectedDate = todayDate;

import { onMount } from "svelte";
onMount(async () => {
  // calc today
  // calcMonth(today);
});


function calcMonth(wantedDate) {
  curYear = wantedDate.getFullYear();
  curMonth = wantedDate.getMonth();
  curDate = wantedDate.getDate();
  
  weeks = [ [], [], [], [], [], [], ];
  
  // figure out start day for 1st of the month
  
  // use curMonth to calc the white space before the 1st calendar day of the month
  let sdate = new Date(curYear, curMonth, 1);
  startDay = sdate.getDay();
  
  // create empty items padding for first days of the month
  emptyDays = [];
  for (let i = 0; i < startDay; i++) {
    emptyDays.push(i);
  }
  
  // start dates
  daysInMonth = new Date(curYear, curMonth+1, 0).getDate();
  
  curWeek = 0;
  curDay = startDay;
  for (let i = 1; i <= daysInMonth; i++) {
    weeks[curWeek].push(i);
    
    curDay++;
    if (curDay > 6) {
      curDay = 0;
      curWeek++;
    }
  }
}


function nextMonth() {
  curMonth++;
  calcMonth(new Date(curYear, curMonth, curDate));
}


function previousMonth() {
  curMonth--;
  calcMonth(new Date(curYear, curMonth, curDate));
}


function isToday(theDate) {
  if (curYear == todayYear && curMonth == todayMonth && theDate == todayDate) {
    return true;
  }
  
  return false;
}


function isSelected(theDate) {
  if (curYear == selectedYear && curMonth == selectedMonth && theDate == selectedDate) {
    return true;
  }
  
  return false;
}


function selectThisDate(item) {
  selectedYear = curYear;
  
  selectedMonth = parseInt(curMonth) + 1;
  if (selectedMonth < 10) selectedMonth = "0" + selectedMonth;
  
  selectedDate = parseInt(item);
  if (selectedDate < 10) selectedDate = "0" + selectedDate;
  
  date = selectedYear + "-" + selectedMonth + "-" + selectedDate;
  // console.log("calendar date:", date);
}

</script>